import { render, staticRenderFns } from "./message-item.html?vue&type=template&id=59f61ba1&scoped=true&"
import script from "./message-item.js?vue&type=script&lang=js&"
export * from "./message-item.js?vue&type=script&lang=js&"
import style0 from "./message-item.scss?vue&type=style&index=0&id=59f61ba1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f61ba1",
  null
  
)

export default component.exports